import GLightbox from 'glightbox'
import eventBus from "../utils/eventBus";

const lightBoxElements = document.querySelectorAll('.u-lightbox--collection')

const globalLightbox = GLightbox();

globalLightbox.on('slide_changed', ({ current }) => {
  eventBus.emit('lightbox-slide-changed', { node: current.trigger.closest('.c-slider'), current })
})

if (lightBoxElements) {
  lightBoxElements.forEach(lightboxEl => {
    const lightboxTrigger = lightboxEl.querySelector('.u-lightbox__trigger')
    const images = lightboxEl.querySelectorAll('.c-img')

    const lightbox = GLightbox({
      selector: lightboxEl,
      elements: Array.from(images).map(image => {
        return {
          href: image.dataset.original,
          type: 'image'
        }
      })
    })

    lightbox.on('slide_changed', ({ current }) => {
      eventBus.emit('lightbox-slide-changed', { node: lightboxEl, current })
    })

    let currentSliderIndex = 0

    eventBus.on('slider-slide-changed', (ev) => {
      currentSliderIndex = ev.detail
    })

    lightboxTrigger.addEventListener('click',
      () => lightbox.openAt(0)
    )
  })
}

const lightbox = GLightbox({
  selector: '.u-lightbox',
  touchNavigation: true,
  loop: true,
  autoplayVideos: true
});

const teamLightbox = GLightbox({
  selector: '[data-team-lightbox]',
  touchNavigation: true,
  loop: true,
  skin: 'clean glightbox-team',
  autoplayVideos: false,
  moreLength: 0
});
